export default "__VITE_ASSET__rFA0pJbw__"